module.exports = __webpack_public_path__ + "static/media/appai.fa35476d.png";